import AppToolbar                   from "./app-toolbar.vue";
import AppNavigationDrawer          from "./app-navigation-drawer.vue";
import AppNavigationDrawerSettings  from "./app-navigation-drawer-settings.vue";
import BtnScrollTop                 from "./btn-scroll-top.vue";
// This is a description of the component
// DefaultLayout : The application layout
// @group DefaultLayout
export default {
    components: {
        AppToolbar,
        AppNavigationDrawer,
        AppNavigationDrawerSettings,
        BtnScrollTop
    },
    data() {
        return {
            drawer : {
                show : true
            },
            rightDrawer : {
                show : false
            }
        };
    },
    methods: {
        handleDrawerVisible() {
            this.drawer.show = !this.drawer.show;
        },
        onSettingsIconClick() {
            this.rightDrawer.show = !this.rightDrawer.show
        }
    },
    created(){
        let userLanguage = 'de';
        let userThemeDark = false;
        if(localStorage.getItem('userLanguage')) {
            userLanguage = localStorage.getItem('userLanguage');
        } else {
            localStorage.setItem('userLanguage', userLanguage);
        }
        if(localStorage.getItem('userThemeDark')) {
            console.info('here01');
            userThemeDark = localStorage.getItem('userThemeDark');
        } else {
            console.info('here02');
            localStorage.setItem('userThemeDark', userThemeDark);
        }
        console.log(typeof userThemeDark);
        this.$i18n.locale = userLanguage;
        if(userThemeDark == 'true') {
            console.info('userThemeDark true', userThemeDark);
            this.$vuetify.theme.dark = true;
        } else {
            console.info('userThemeDark false', userThemeDark);
            this.$vuetify.theme.dark = false;
        }
        // this.$vuetify.theme.dark = false;
    }
    // watch: {
    //     '$vuetify.breakpoint.mdAndDown': function () {
    //         this.drawer.show        = false;
    //     },
    // }
};
